'use strict';

module.exports = {
  NOT_AUTHENTICATED: 'Not authenticated',
  NOT_AUTHORIZED: '401',
  UNKNOWN_PAGE: '404',
  UNKNOWN_SITE: 'Unknown site',
};


// WEBPACK FOOTER //
// ./src/common/Errors.js